module.exports = {"id":"223875","name":"Yacine Bammou","rating":"72","photo":"./data/images/photos/4/223875.png","club":{"name":"FC Nantes","logo":"./data/images/clubs/FCNantes.png"},"positions":["BU","MOC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YacineBammou0.json
// module id = 4372
// module chunks = 0